function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSuccessFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 2a14.003 14.003 0 0114 14c0 7.732-6.268 14-14 14S2 23.731 2 16 8.268 2 16 2zm-3.07 16.884l-3.372-3.372L8 17.07 12.93 22l10.442-10.442L21.814 10l-8.884 8.884z",
    fill: props.color
  }));
}

export default SvgIconSuccessFilled;